import classNames from 'classnames';
import React from 'react';
import getClsWithPrefix from '../cls';
import './index.less';

const subPrefix = 'Button';
const cls$ = getClsWithPrefix(subPrefix);

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    type?: 'default' | 'primary' | 'text' | 'border';
    htmlType?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
    icon?: React.ReactNode;
    size?: 'small' | 'middle' | 'large';
    disabled?: boolean;
    loading?:
        | boolean
        | {
              delay?: number;
          };
    className?: string;
    ghost?: boolean;
    children?: React.ReactNode;
    classNames?: {
        icon: string;
    };
    styles?: {
        icon: React.CSSProperties;
    };
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className = '', icon, type = 'default', htmlType = 'button', size = 'large', children, ...restProps }, ref) => {
        return (
            <button
                /* eslint-disable-next-line react/button-has-type */
                type={htmlType}
                className={classNames(cls$(), className)}
                data-type={type}
                data-size={size}
                {...restProps}
                ref={ref}
            >
                {icon}
                <div className={cls$('children')}>{children}</div>
            </button>
        );
    },
);

export default Button;
